/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   MobileNavContext.ts
 */

import { DEFAULT_FILTERS } from '@zcode-ui/filters'
import type { Filters } from '@zcode/state-type'
import { createContext } from 'react'
import { NAV_MODAL_TYPES } from './constants'

export const MobileNavContext = createContext({
  newFilters: DEFAULT_FILTERS,
  setNewFilters: (newFilters: Filters) => {},
  modalType: NAV_MODAL_TYPES.ROOMS as (typeof NAV_MODAL_TYPES)[keyof typeof NAV_MODAL_TYPES],
  setModalType: (modalType: (typeof NAV_MODAL_TYPES)[keyof typeof NAV_MODAL_TYPES]) => {},
  isOpen: false,
  onClose: () => {},
  onOpen: () => {},
})
